export const IS_DEMO = process.env.PUBLIC_DEMO === "true";
